export const RESET_AUTHENTICATION_STATE = 'auth/RESET_AUTHENTICATION_STATE';
export const SET_ACCESS_TOKEN = 'auth/SET_ACCESS_TOKEN';
export const SET_REFRESH_TOKEN = 'auth/SET_REFRESH_TOKEN';
export const SET_INITIAL_TOKEN = 'auth/SET_INITIAL_TOKEN';
export const SET_PIN_AUTH_TOKEN = 'auth/SET_PIN_AUTH_TOKEN';
